// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // Your web app's Firebase configuration
  firebaseConfig: {
    apiKey: 'AIzaSyDw64cxB6C1GFYJjUy-T_V_NxjluwH9iLQ',
    authDomain: 'eje-255407.firebaseapp.com',
    databaseURL: 'https://eje-255407.firebaseio.com',
    projectId: 'eje-255407',
    storageBucket: 'eje-255407.appspot.com',
    messagingSenderId: '536638361237',
    appId: '1:536638361237:web:18a2ccc24ae0be3bf2959c',
    measurementId: 'G-C91QCFBH4S'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
